module.exports = __webpack_public_path__ + "media/images/emblems/Wangen-Bruettisellen-blazon-a68a02f567d37fb631191da729abbe98.svg";